import { createFileRoute } from '@tanstack/react-router'
import { assistantSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/assistant/smart-appraisal')({
  validateSearch: (search) => assistantSearchSchema.parse(search),
  loaderDeps: () => ({}),
})
